export function hasValue(obj: any, val: any): boolean {
  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      if (obj[key] === val) {
        return true;
      } else if (typeof obj[key] === 'object') {
        if (hasValue(obj[key], val)) {
          return true;
        }
      }
    }
  }
  return false;
}

export function hasSomeValues(obj: any, arrVal: any[]): boolean {
  for (let val of arrVal) {
    if (hasValue(obj, val) === true) {
      return true;
    }
  }
  return false;
}

export function capitalize(str: string) {
  return str.charAt(0).toLocaleUpperCase() + str.slice(1);
}

// Typescript function that limit the length of a string and complete the rest with 3 dots
export function limitLength(str: string, level: number, limit: number) {
  if(level == 2 || level == 3){
    limit = 17
  }
  if (str.length > limit) {
    return str.substring(0, limit) + '...';
  }
  return str;
}